<template>
  <div class="card" v-show="cardShow">
    <div class="cont">
      <em class="cursor close" @click="close"></em>
      <h2>答题卡</h2>
      <ul>
        <li
          class="cursor"
          v-for="(v, i) in data.progress"
          :class="{ cur: v.status!=-1, mr0: (i + 1) % 5 == 0 }"
          :key="i"
          @click="jump(i+1)"
        >
          {{ v.index }}
        </li>
      </ul>
      <div class="btn">
        <button class="cursor" :class="{ cur: btnIsCanClick }" @click="submit"></button>
        <p v-if="btnIsCanClick">小朋友，你的所有题目已完成，是否提交？</p>
        <p v-else>小朋友，完成所有题目才可以提交哦～</p>
      </div>
      <button class="reset cursor" @click="resetQuestion" v-if="isGhost"><i>↻</i>重新做题</button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      cardShow:true
    };
  },
  props:{
    data:{
      type:Object,
      required:true
    }
  },
  computed:{
    ...mapState(["lesson_id", "class_id", "userID","isGhost"]),
    btnIsCanClick(){
      let arr = this.data.progress || [];
      if(!arr.length) return false;
      const index = arr.findIndex((v)=>{
        return v.status==-1;
      })
      return index===-1?true:false;
    }
  },
  created() {
    
  },
  methods: {
    ...mapActions([
      "exerciseSubmit",
    ]),
    close() {
      this.$emit("close");
    },
    submit() {
      //答题卡提交
      this.cardShow = false;
      this.exerciseSubmit({
        classId: this.class_id,
        count: this.data.progress.length,
        lessonId: this.lesson_id,
        studentId: this.userID,
      }).then(({ res, ok }) => {
       if(ok){
          this.$emit("submitSuccess")
       }else{
          if(res.code==='EXE111'){
            this.$emit("showToast",{type:0,text:res.message});
            setTimeout(()=>{
              this.$emit("submitSuccess");
            },3000)
          }else{
             this.close();
          }
       }
       
      },()=>{
        this.close();
      }).catch(()=>{
        this.close();
      })
    },
    jump(index){
      this.$emit("jump",index);
      this.close();
    },
    resetQuestion(){
      this.$emit("resetQuestion");
    }
  },
};
</script>
<style lang="less" scoped rel="stylesheet/less">
.card {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.cont {
  position: relative;
  width: 578px;
  height: 400px;
  background: url("../../../assets/img/homework/card_bg.png") no-repeat;
  background-size: cover;
  border-radius: 30px;
}
.close {
  position: absolute;
  width: 44px;
  height: 44px;
  background: url("../../../assets/img/common/close1.png") no-repeat;
  background-size: cover;
  right: -44px;
  top: -44px;
}
h2 {
  font-size: 30px;
  font-weight: HEW;
  color: #004466;
  padding-top: 33px;
  &::before,
  &::after {
    content: " ";
    display: inline-block;
    width: 32px;
    height: 25px;
    background: url("../../../assets/img/homework/card_l.png") no-repeat;
    background-size: cover;
    margin-right: 16px;
    transform: translateY(2px);
  }
  &::after {
    background: url("../../../assets/img/homework/card_r.png") no-repeat;
    background-size: cover;
    margin-left: 16px;
    margin-right: 0;
  }
}
::-webkit-scrollbar {
  width: 0px;
}
ul {
  width: 490px;
  margin: 12px auto 0;
  height: 150px;
  border-bottom: 1px dashed #5ac1eb;
  overflow-y: auto;
  padding-bottom: 20px;
  li {
    float: left;
    width: 67px;
    min-width: 67px;
    height: 67px;
    border-radius: 50%;
    text-align: center;
    line-height: 60px;
    border: 3px solid #4dbae6;
    font-size: 30px;
    color: #4dbae6;
    margin-right: 38px;
    margin-top: 30px;
    font-weight: 600;
  }
  .mr0 {
    margin-right: 0;
  }
  .cur {
    background: #4dbae6;
    color: #ffffff;
  }
}
.btn {
  margin-top: 30px;
  button {
    width: 191px;
    height: 64px;
    background: url("../../../assets/img/homework/btn.png") no-repeat;
    background-size: cover;
    pointer-events: none;
  }
  .cur {
    pointer-events: auto;
    background: url("../../../assets/img/homework/btn_cur.png") no-repeat;
    background-size: cover;
  }
  p {
    margin-top: 8px;
    font-size: 18px;
    color: #004466;
  }
}
.reset{
  position: absolute;
  top: 37px;
  right: 40px;
  color:#3FBAE8;
  font-size: 16px;
  i{
    font-size: 22px;
    display: inline-block;
    transform: translate(-3px, 2px);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/homework/card.vue